<template>
  <div>
    <a-modal :centered="true" width="100%" height="100%" v-model="showModal" :footer="null" :bodyStyle="{ padding: 0, display: 'flex', justifyContent: 'center' }" @cancel="hide">
      <div class="report-page-container">
        <img class="report-side-image" src="../../assets/images/report-side-img.png" alt="side-image" />
        <div class="report-side-image-dub"></div>
        <div v-if="page === 0" class="report-right-side-container">
          <div style="width: 100%; min-width: 300px; max-width: 581px">
            <p class="report-title">Report</p>
            <p class="report-subtitle">Please select a problem.</p>
            <button v-for="report_choices_item in report_choices_list" :key="report_choices_item" class="report-choice-button" @click="setValue(report_choices_item)">
              {{ report_choices_item }}
            </button>
          </div>
        </div>
        <div v-if="page === 1" class="report-right-side-container" style="justify-content: start; padding-top: 120px">
          <div>
            <p class="report-title">Report</p>
            <p class="report-subtitle">Tell us more about this problem.</p>
            <textarea class="report-describe-textfield" placeholder="Describe the problem..." rows="10" cols="30" v-model="spam_desc" />
            <div class="button-container">
              <button
                class="report-submit-button2"
                @click="page--"
                :style="{
                  background: '#E2E8F0',
                  marginRight: '20px',
                  color: '#47556E',
                }"
              >
                Back
              </button>
              <button class="report-submit-button2" @click="save" :style="{ background: getPrimaryColor() }">Submit</button>
            </div>
            <button class="report-submit-button" @click="save" :style="{ background: getPrimaryColor() }">Submit</button>
          </div>
        </div>
        <div v-if="page === 2" class="report-right-side-container" style="justify-content: start; padding-top: 120px">
          <img class="report-success-check-img" src="../../assets/images/success-check-img.png" alt="side-image" />
          <p class="report-title" style="text-align: center">Thank you for reporting!</p>
          <p class="report-subtitle" style="width: 100%; min-width: 300px; max-width: 581px; text-align: center; margin-bottom: 24px">
            DoveMed will review your submission and inform you once the issue is resolved, or if needed we will contact you for further assistance.
          </p>
          <button class="report-continue-button" @click="hide" :style="{ background: getPrimaryColor() }">Continue</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { eventBus } from "../../main"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "ReportContent",
  data() {
    return {
      showModal: false,
      max: 500,
      value: "",
      post: null,
      spam_desc: "",
      page: 0,
      type: 1,
      user_role: "",
      report_choices_list: ["Nudity", "Hate Speech", "Profile Image Is Inappropriate", "Name Is Inappropriate", "Not A Real Person", "Spam", "Something Else"],
    }
  },
  methods: {
    show(data, type) {
      // console.log(data, type, this.page)
      this.showModal = true
      // console.log(this.showModal,"showmodal")
      this.post = data ? data : {}
      this.type = type
      // console.log("inside report modal");
    },
    hide() {
      // console.log("inside hide")
      this.showModal = false
      this.spam_desc = ""
      this.page = 0
    },
    setValue(report_choices_item) {
      this.value = report_choices_item
      this.page++
    },
    save() {
      if (this.type === 15) {
        PostRepository.saveReaction(this.currentCircle.id, {
          reacted_on_type: this.type,
          reacted_on_id: this.viewUser.id,
          user: this.authUser.user.ext_ref_id ? this.authUser.user.ext_ref_id : this.authUser.user.id,
          reaction_type: 5,
          spam: this.value,
          spam_description: this.spam_desc,
          report_profile_role: this.viewUser.role,
        })
        this.page++
      } else {
        const payload = { is_spam: true }
        PostRepository.reportContent(this.post.id, payload, this.type)
          .then(res => {
            PostRepository.saveReaction(this.currentCircle.id, {
              reacted_on_type: this.type,
              reacted_on_id: this.post.id,
              user: this.authUser.user.id,
              reaction_type: 5,
              spam: this.value,
              spam_description: this.spam_desc,
            })
            eventBus.$emit("refresh-posts")
            eventBus.$emit("flag-post", { id: this.post.id })
            this.page++
          })
          .catch(err => null)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.report-page-container {
  display: flex;
  max-width: 1840px;
  width: 100%;
  height: 100%;
}

.report-side-image {
  @media only screen and (max-width: 800px) {
    display: none;
  }
  align-self: stretch;
  height: 100vh;
  background-size: cover;
  border-radius: 5px 0px 0px 5px;
  object-fit: cover;
  position: fixed;
  top: 0px;
  left: 0px;
}

.report-side-image-dub {
  flex: 0.28;
  height: 100vh;
  min-width: 380px;
  @media only screen and (max-width: 800px) {
    min-width: 1px;
  }
}

.report-right-side-container {
  display: flex;
  @media only screen and (min-width: 801px) {
    flex: 0.72;
  }
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
}

.report-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 32px;
  color: #0f1734;
  margin: 0px;
}

.report-subtitle {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  color: #647490;
  margin-top: 8px;
  margin-bottom: 35px;
}

.report-choice-button {
  display: inline;
  width: 100%;
  height: 60px;
  background: #f1f5f9;
  border-radius: 6px;
  border: none;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #1e2945;
  text-align: start;
  padding-left: 24px;
  margin-bottom: 16px;
  cursor: pointer;
}

.report-choice-button:hover{
  background-color: #e2e8f0;
}

.report-describe-textfield {
  width: 100%;
  min-width: 300px;
  max-width: 581px;
  height: 170px;
  resize: none;
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #1e2945;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
}

.button-container {
  @media only screen and (max-width: 800px) {
    display: flex;
    justify-content: flex-end;
  }
  @media only screen and (min-width: 801px) {
    display: none;
  }
  width: 100%;
  min-width: 300px;
  max-width: 581px;
}
.report-submit-button2 {
  @media only screen and (max-width: 800px) {
    width: 100px;
  }
  height: 48px;
  border-radius: 6px;
  border: none;
  text-align: center;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  margin-top: 24px;
  cursor: pointer;
}
.report-submit-button {
  @media only screen and (min-width: 801px) {
    width: 100%;
    min-width: 300px;
    max-width: 581px;
  }
  @media only screen and (max-width: 800px) {
    display: none;
  }
  height: 48px;
  border-radius: 6px;
  border: none;
  text-align: center;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  margin-top: 24px;
  cursor: pointer;
}

.report-success-check-img {
  margin-bottom: 29px;
  min-width: 68px;
  height: 68px;
  background-size: cover;
}

.report-continue-button {
  width: 106px;
  height: 48px;
  border-radius: 6px;
  border: none;
  text-align: center;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ReportContent.vue